import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

export async function generateOverlayEstimatePDF(application) {
  if (!application?.estimatePdfUrl) {
    alert("Estimate PDF URL missing.");
    return;
  }

  const existingPdfBytes = await fetch(application.estimatePdfUrl).then((res) =>
    res.arrayBuffer()
  );

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];

  const { height } = firstPage.getSize();

  firstPage.drawText(`PACS / Society: ${application.societyName || "-"}`, {
    x: 45,
    y: height - 55,
    size: 11,
    font,
    color: rgb(0, 0, 0),
  });

  firstPage.drawText(`Registration No: ${application.registrationNo || "-"}`, {
    x: 45,
    y: height - 72,
    size: 10,
    font,
    color: rgb(0, 0, 0),
  });

  firstPage.drawText(`Address: ${application.address || "-"}`, {
    x: 45,
    y: height - 89,
    size: 10,
    font,
    color: rgb(0, 0, 0),
  });

  firstPage.drawText(`District: ${application.district || "-"}`, {
    x: 45,
    y: height - 106,
    size: 10,
    font,
    color: rgb(0, 0, 0),
  });

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Estimate_${application.societyName || "PACS"}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}